import React from "react";
import { Modal, Form, Input, Button, Radio, Dropdown ,Space, Select} from "antd";

import useSubUserStore from "../../store/subUserModal.store";

import "./projectAddModal.scss";
import useProjectStore from "../../store/projectModal.store";

export default function ProjectAddModal() {
    const { isModalOpenP, handleModalPCancel, handleProjectAdd } = useProjectStore();
    const [form] = Form.useForm();

    const handleFormSubmit = (value) => {
        handleProjectAdd(value.projectname);
        handleModalPCancel();
        form.resetFields();
    };

    return (
        <Modal
            title= {"Add / Remove Projects"}
            visible={isModalOpenP}
            footer={null}
            onCancel={handleModalPCancel}
            className="subUserAddModel-title"
        >
            <Form
                    labelCol={{ flex: "150px" }}
                    labelAlign="left"
                    labelWrap
                    wrapperCol={{ flex: 1 }}
                    colon={false}
                    onFinish={handleFormSubmit}
                    form={form}
            >               
                    <Form.Item
                        rules={[
                            {
                                required: true,
                                message: "Add New Project Name",
                            },
                        ]}
                        label="Project Name"
                        name="projectname"
                    >
                        <Input   className="subUserAddModel-input"/>
                    </Form.Item>
                    <Button htmlType="submit" type="primary">
                        Submit
                    </Button>
            </Form>
        </Modal>
    );
}
